"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidModel = isValidModel;
const isObject = (v) => typeof v === 'object' && v !== null;
const isString = (v) => typeof v === 'string';
const isPlayerIndex = (v) => v === 0 || v === 1;
const isDie = (v) => v === 1 || v === 2 || v === 3 || v === 4 || v === 5 || v === 6;
const isDice = (v) => isObject(v) && isDie(v['die1']) && isDie(v['die2']);
const isLiveTurn = (v) => v === undefined || v === null || (isObject(v) && Array.isArray(v['moves']));
function isUser(v) {
    if (!isObject(v))
        return false;
    if (!isString(v['uid']) ||
        !isString(v['email']) ||
        !isString(v['displayName']) ||
        !isString(v['photoURL'])) {
        return false;
    }
    if (v['messagingToken'] !== undefined && !isString(v['messagingToken'])) {
        return false;
    }
    return true;
}
function isGameState(v) {
    if (!isObject(v))
        return false;
    switch (v['state']) {
        case 'created':
            return true;
        case 'in-progress':
            return (isPlayerIndex(v['turn']) &&
                (v['dice'] === null || isDice(v['dice'])) &&
                isObject(v['board']) &&
                isLiveTurn(v['liveTurn']));
        case 'game-over':
            return (isPlayerIndex(v['winner']) &&
                (v['winType'] === 'normal' ||
                    v['winType'] === 'gammon' ||
                    v['winType'] === 'backgammon'));
        default:
            return false;
    }
}
/**
 * Trust-boundary shape guard for a `Model` read from an untrusted source
 * (e.g. a client-written Firestore document). Validates the fields the server
 * reads — NOT board move-legality (that stays client-authoritative). An
 * in-progress or game-over model must have BOTH players present, which justifies
 * indexing `players[turn]` without a null check downstream.
 */
function isValidModel(value) {
    if (!isObject(value))
        return false;
    const { gameId, rules, players, gameState, history } = value;
    if (!isString(gameId))
        return false;
    if (rules !== 'standard' && rules !== 'roro')
        return false;
    if (!Array.isArray(players) || players.length !== 2)
        return false;
    const [p0, p1] = players;
    if (!(p0 === null || isUser(p0)))
        return false;
    if (!(p1 === null || isUser(p1)))
        return false;
    if (!isGameState(gameState))
        return false;
    if (!Array.isArray(history))
        return false;
    if ((gameState.state === 'in-progress' || gameState.state === 'game-over') &&
        (p0 === null || p1 === null)) {
        return false;
    }
    return true;
}
